import projects from "./projects.json";

export default { projects };
